import axiosInstance from "../../utils/axiosInstance";
import { buildQueryParams } from './../../services/utility';

const list = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`subscription/user-subscriptions?${queryString}`);
  return response.data.data;
};

const userSubscription = {
  list,
};

export default userSubscription;
